// Paint Usage report routes.
import React from "react";

const ShowPaintUsage = React.lazy(() => import("./show"));

export default [
  {
    path: "/production/paint_usage",
    component: ShowPaintUsage,
    name: "Paint Usage",
  },
];
